// Specific validators
export const validateCity = (value) => hasAtLeastOneLetter(value) + hasNoDigits(value);
export const validateEmailAddress = (value) => /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)
    ? ""
    : "Must be a valid email address. ";
export const validateName = (value) => hasNoDigits(value) + hasAtLeastOneLetter(value);
export const validatePhoneNumber = (value) => /^\d{10}$/.test(value) ? "" : "Must be a 10-digit US phone number. ";
export const validateTaxId = (value, isStaging) => {
    // The staging endpoint allows fake SSN's starting with '666' (can I put devil horns in here?)
    const regex = isStaging
        ? /^(?!000)(?!123456789)(?![0-9][0-9][0-9]00)(?![0-9]{5}0000)(?!9)(?!(\d)\1{8})\d{9}$/
        : /^(?!666)(?!000)(?!123456789)(?![0-9][0-9][0-9]00)(?![0-9]{5}0000)(?!9)(?!(\d)\1{8})\d{9}$/;
    return regex.test(value) ? "" : "Invalid Tax ID. ";
};
// General validators
export const hasAtLeastOneLetter = (value) => /[a-zA-Z]/.test(value)
    ? ""
    : "Must contain at least one English letter (A-Z). ";
export const hasNoDigits = (value) => !/\d/g.test(value) ? "" : "Must not contain digits (0-9). ";
export const valuesMatch = (value1, value2) => {
    return value1 === value2 ? "" : "Values must match.";
};
export const isGreaterThan = (value, compareValue = 0) => value > compareValue ? "" : `Value must be greater than ${compareValue}.`;
export const isValidDate = (value) => {
    const date = new Date(value);
    return date instanceof Date && !isNaN(date.getTime()) ? "" : "Invalid date.";
};
